import { Button, TableCell, TableRow } from '@material-ui/core'
import React from 'react'
import { formatCurrencyPesos } from '../../../../../../helpers/extraFunctions';
import { getTraerSolicitudBandejaImagenesSurge } from '../../../../../../actions/autorizaciones/Autorizaciones';
import { useDispatch } from 'react-redux';

export const ItemsSolPago = (props) => {

  const { item, setOpenModalInfo } = props;
  const dispatch = useDispatch();

  return (
    <TableRow>
      <TableCell align="left">{item?.idSolicitudPago}</TableCell>
      <TableCell align="left">{item?.solPagAnterior}</TableCell>
      <TableCell align="left">{item?.idSolicitud}</TableCell>
      <TableCell align="left">{item?.apellido_nombre}</TableCell>
      <TableCell align="left">{item?.cod_nom}</TableCell>
      <TableCell align="left">{item?.des_nom}</TableCell>
      <TableCell align="left">{item?.cant}</TableCell>
      <TableCell align="left">{item?.diagnostico}</TableCell>
      <TableCell align="left">{item?.razonSocial}</TableCell>
      <TableCell align="left">{item?.expAnterior}</TableCell>
      <TableCell align="left">{item?.nroDeComprobante}</TableCell>
      <TableCell align="left">
        {item?.fechaComp ? new Date(item.fechaComp).toLocaleDateString('es-AR') : ''}
      </TableCell>
      <TableCell align="left">{`${formatCurrencyPesos(item?.impFact)}`}</TableCell>
      <TableCell align="left">
        <Button
          style={{ fontSize: "0.8rem" }}
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(getTraerSolicitudBandejaImagenesSurge(item?.idSolicitud, item.idEstadoSolicitud, setOpenModalInfo))
          }}
        >
          Abrir
        </Button>
      </TableCell>
    </TableRow>
  )
}
